import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/logo_white.svg";
import { ReactComponent as EnterpriseLogo } from "../../assets/enterpriseLogo.svg";
import { ReactComponent as D1 } from "../../assets/icons/dashbaord_nav_1.svg";
import { ReactComponent as D0 } from "../../assets/icons/dashboard_0.svg";
import { ReactComponent as D4 } from "../../assets/icons/dashboard_subs_4.svg";
import { ReactComponent as D5 } from "../../assets/icons/dashboard_company_5.svg";
import { ReactComponent as D6 } from "../../assets/icons/dashboardCart.svg";
import { ReactComponent as D7 } from "../../assets/icons/dashboardRequest.svg";
import { ReactComponent as D8 } from "../../assets/icons/paymentRef.svg";
import { ReactComponent as D9 } from "../../assets/icons/graduation-cap.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logoutIcon.svg";
import { ReactComponent as CollapsedLogo } from "../../assets/icons/collapsedLogo.svg";
import { ReactComponent as OrangeLeftArrow } from "../../assets/icons/orangeLeftArrow.svg";
import { Profile, SidebarLinkGroup } from "../../components/admin/Dashboard";
import { Modal, Logout } from "../../components/common";
import TorchEffect from "../../components/torchEffect/TorchEffect";
import CommonTooltip from "../../components/common/Tooltip";
import ReactDOM from "react-dom";

const Sidebar = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const [isOpen, setIsOpen] = useState(false);
  const [links, setLinks] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const sidebarRef = useRef(null);
  const k_HUB_URL = process.env.REACT_APP_K_HUB_URL
  const PAYMENT_REF = process.env.REACT_APP_PAYMENT_REF
  console.log(PAYMENT_REF, "PAYMENT_REF");


  useEffect(() => {
    if (!userInfo) return;

    const initialLinks = [
      { name: "Dashboard", link: "/dashboard", Icon: D0 },
      { name: "My Companies", link: "/dashboard/my-companies", Icon: D5 },
      { name: "Following", link: "/dashboard/following", Icon: D1 },
      { name: "Requests", link: "/dashboard/request", Icon: D7 },
      { name: "Billing", link: "/dashboard/billing", Icon: D4 },
      { name: "Purchased", link: "/dashboard/purchased", Icon: D6 },
      { name: "Knowledge Hub", link: "/dashboard/article", Icon: D9, newTab: false },

      PAYMENT_REF === "true" && {
        name: "Payment References Hub",
        link: "/dashboard/payment-ref",
        Icon: D8,
        newTab: false,
      },

      { name: "Enterprise", link: "/dashboard/enterprise", Icon: D5 },
      { name: "Help & Support", link: "/dashboard/help", Icon: D1 },
    ].filter(Boolean);


    const notifications = userInfo.notifications || [];
    const alerts = notifications.reduce((acc, notification) => {
      if (!notification.is_read) {
        const alertTypeMapping = {
          request: ["My Companies", "Requests"],
          follow: ["Following"],
          payment: ["Billing"],
          order_request: ["Purchased"],
          enterprise: ["Enterprise"],
          support_ticket: ["Help"],
        };
        alertTypeMapping[notification.type]?.forEach((item) => {
          acc[item] = true;
        });
      }
      return acc;
    }, {});

    const updatedLinks = initialLinks.map((link) => ({
      ...link,
      alert: alerts[link.name] || false,
    }));

    setLinks(updatedLinks);
  }, [userInfo]);

  // 👇 Track width properly
  useEffect(() => {
    const handleResize = () => {
      const containerWidth = window.innerWidth; // or use a parent div ref if needed
      setCollapsed(containerWidth < 1050);
      // 👆 because 20% of 1050px = 210px
    };

    // run once on mount
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const modalHandle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleCollapse = () => {
    setCollapsed(!collapsed)
  }

  return (
    <div
      ref={sidebarRef}
      className={`relative overflow-visible hidden sm:block transition-all duration-300 
        ${collapsed ? "w-[68px]" : "w-[20%] max-w-[240px]"}`}
    >
      <TorchEffect style={{ backgroundColor: "rgba(0,0,0,0.4)", width: "100%" }} autoHeight={true}>
        {isOpen && (
          <Modal modalHandle={modalHandle}>
            <Logout close={modalHandle} />
          </Modal>
        )}
        <div className={`min-h-screen ${collapsed ? "w-[68px]" : "w-[20%] max-w-[240px]"} sm:flex items-start py-8 p-4`}>
          <div className="w-full h-full">
            <div className="flex flex-col justify-between h-full">
              <div>
                <Link to="/" className={`flex items-start ${userInfo?.enterprise_solutions?.length > 0 && !collapsed ? "justify-start pl-2" : "justify-center"}`}>
                  {collapsed ? <CollapsedLogo /> : userInfo?.enterprise_solutions?.length > 0 ? <EnterpriseLogo /> : <Logo />}
                </Link>
                {/* {<Profile collapsed={collapsed} />} */}
                <hr className="border-t border-[#143A4F] my-5" />
                <SidebarLinkGroup links={links} collapsed={collapsed} />
                <button
                  onClick={modalHandle}
                  className="flex items-center text-f14 gap-2 my-1 text-left p-2.5 font-light text-white"
                >
                  <CommonTooltip id={'itemName'} content={collapsed ? 'Logout' : ''}>
                    <LogoutIcon className={`${collapsed ? "h-4 w-4" : "h-6 w-6"}`} />
                  </CommonTooltip>
                  {!collapsed && "Logout"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </TorchEffect>
      <div onClick={handleCollapse} className={`absolute right-[-15px] top-12 w-8 h-8 rounded-full bg-[#FFFBF2] z-[99999] flex justify-center items-center cursor-pointer ${collapsed ? "rotate-180" : ""}`}><OrangeLeftArrow /></div>
    </div>
  );
};

export default Sidebar;

